import { z } from 'zod'
import { Timestamp } from './common.js'

const WAYPOINT_ANCHOR_PATTERN =
  /^waypoint:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const CommentAnchor = z.union([
  z.literal('description'),
  z.string().regex(WAYPOINT_ANCHOR_PATTERN),
])
export type CommentAnchor = z.infer<typeof CommentAnchor>

export const Comment = z.object({
  id: z.string().uuid(),
  route_id: z.string().uuid(),
  anchor: CommentAnchor.nullable(),
  editor_id: z.string().uuid(),
  body_md: z.string().min(1).max(8000),
  created_at: Timestamp,
  edited_at: Timestamp.nullable(),
  status: z.enum(['open', 'resolved']),
})
export type Comment = z.infer<typeof Comment>

export const CommentCreateInput = Comment.pick({ anchor: true, body_md: true })
export type CommentCreateInput = z.infer<typeof CommentCreateInput>

export const CommentUpdateInput = Comment.pick({ body_md: true })
export type CommentUpdateInput = z.infer<typeof CommentUpdateInput>
